export default "__VITE_ASSET__Bdrx3KeM__"